import React from 'react';

function AreaAlarmA() {
  return (
    <>
      <style>{`
        .alarm-wrapper {
          padding: 2rem;
          background-color: #f0f4f8;
          font-family: 'Segoe UI', sans-serif;
        }

        .alarm-card {
          max-width: 800px;
          margin: auto;
          background: #fff;
          padding: 2rem;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }

        .alarm-card h1 {
          text-align: center;
          font-size: 2.2rem;
          color: #2c3e50;
          margin-bottom: 1.5rem;
        }

        .alarm-card img {
          display: block;
          max-width: 100%;
          height: auto;
          margin: 0 auto 1.5rem;
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
        }

        .alarm-card p, .alarm-card li {
          font-size: 1.1rem;
          color: #444;
          line-height: 1.6;
        }

        .alarm-card ul {
          padding-left: 1.5rem;
          margin-top: 0.5rem;
          margin-bottom: 1rem;
        }

        .alarm-card b {
          color: #333;
        }

        @media (max-width: 768px) {
          .alarm-wrapper {
            padding: 1rem;
          }

          .alarm-card {
            padding: 1.2rem;
          }

          .alarm-card h1 {
            font-size: 1.8rem;
          }
        }
      `}</style>

      <main className="alarm-wrapper">
        <section className="alarm-card">
          <h1>Area Alarm (Analog)</h1>
          <img src="aa.png" alt="Area Alarm Analog" />
          <p><b>Available in:</b> 1-gas / 2-gas / 3-gas / 4-gas</p>
          <p><b>Alarm Parameters:</b></p>
          <ul>
            <li>High Pressure</li>
            <li>Normal Pressure</li>
            <li>Low Pressure</li>
          </ul>
          <p><b>Switches:</b> Test, Mute</p>
        </section>
      </main>
    </>
  );
}

export default AreaAlarmA;
